module.exports = __webpack_public_path__ + "img/tailwindcss-stencil.1085e8be.svg";